<template>
  <div class="booking-divider booking-divider-right">
    <div class="booking-content">
      <display-banner/>
      <div class="booking-divider-title text-header-color">Your Address</div>
      <div class="timeslots">
        <div v-if="editing" class="mb-2 text-center">
          <a v-if="canUseLookup" @click.prevent="editing=false" class="link" style="cursor: pointer">
            <i class="fas fa-arrow-left mr-1"></i> Back to Postcode Search
          </a>
          <address-manual-input :validator="addressValidator"/>
        </div>
        <template v-else>
          <div v-if="canUseLookup" class="mb-2 text-center">
            <address-lookup class="mb-2" @selected="editing=true"/>
            <a @click.prevent="editing=true" class="link" style="cursor: pointer">
              <i class="fas fa-keyboard mr-1"></i> Enter Manually
            </a>
          </div>
          <address-manual-input v-else-if="!canUseLookup && loadedCountryFormat" :validator="addressValidator"/>
        </template>
      </div>
    </div>
    <div class="fixed-buttons">
      <button class="btn btn-tertiary w-100 mr-2" @click="back">Back</button>
      <button class="btn btn-secondary w-100 ml-2" @click="next">Next</button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { AddressHelper } from '@/helpers/AddressHelper'
import { FormatCountryCacheMixin } from '@/mixins/Booking/FormatCountryCacheMixin'
import { SubscriptionCacheMixin } from '@/mixins/Booking/SubscriptionCacheMixin'
import ClientAddressManualInput from './ClientAddressManualInput.vue'
import ClientAddressLookup from './ClientAddressLookup.vue'
import DisplayBanner from '../DisplayBanner.vue'

export default {
  name: 'ClientAddress',
  mixins: [FormatCountryCacheMixin, SubscriptionCacheMixin],
  data () {
    return {
      addressValidator: AddressHelper.getAddressValidator(),
      editing: false
    }
  },
  computed: {
    ...mapState('BookingUpload', [
      'clientAddress'
    ]),
    addressString () {
      return AddressHelper.getAddressLines(this.clientAddress).join(', ')
    },
    featureKey () {
      return 'postcodeAllowed'
    },
    canUseLookup () {
      return this.countryFormat && this.countryFormat.addressLookup && this.postcodeLookupAllowed
    }
  },
  methods: {
    back () {
      this.$emit('back')
    },
    next () {
      this.addressValidator.check(this.clientAddress)
      if (this.addressValidator.isValid) {
        this.$emit('next')
      }
    }
  },
  components: {
    'display-banner': DisplayBanner,
    'address-manual-input': ClientAddressManualInput,
    'address-lookup': ClientAddressLookup
  }
}
</script>
